import { useState } from 'react';
import styled from '@emotion/styled'

import { Grid, Card, Button } from '@mui/material'

import { Panel, SwitchSection, Section, HebrewSpan, TagField, TagRuleDescription, ErrorList, TagRules, validateTemplate } from '../../Common'


import { usePageData } from '../../../../contexts/PageData';
import { useEffect } from 'react';
import RadioCards from '../../Components/RadioCards';

import SmsQuotaBanner from '../Components/SmsQuota';

const GeneralTab = () => {

  const { data, modifySetting } = usePageData() || {};

  console.log(data?.data, "data");

  let setting = data?.data || {};

  const [format_fields, setFormatFields] = useState({
    confirm_message: null,
    dropoff_message: null,
    appt_message: null,
    repair_msg: null
  })

  const [format_fields_errors, setFormatFieldsErrors] = useState({
    confirm_message: null,
    dropoff_message: null,
    appt_message: null,
    repair_msg: null
  });

    const handleChange = (e, field) => {
    let val = e.target.value;
    setFormatFieldsErrors(x => ({...x, [field]: null}));
    setFormatFields(x => ({...x, [field]: val}));
  }

  useEffect(() => {
    if (setting) {
      setFormatFields(ov => {
        let obj = {}
        Object.keys(ov).forEach(key => {
          obj[key] = setting?.[key] || ov[key]
        });
        return obj
      })
    }
  }, [setting]);

  const submitFormat = (e, field) => {
      let validPlaceholders = field === "repair_msg" ? ["full_name", "first_name", "last_name", "wig_id", "location"] : ["event_title", "stylist_name", "date", "start_time", "end_time", "first_name", "last_name", "full_name", "location"];
      let val = format_fields[field];
      let validatedString = validateTemplate(val, validPlaceholders);
      if (!validatedString.isValid) {
        setFormatFieldsErrors(x => ({
          ...x,
          [field]: validatedString.errors
        }));
        return;
      }
      modifySetting(val, field, data?.setting_id);
    }

  return (
    <Panel>
      <SmsQuotaBanner />

      <SwitchSection title="Appointment Notifications" description="Notify customers about their upcoming appointments by SMS" switchName="notify_appointment" />

      <SwitchSection title="Confirm Scheduled Appointments" description="Confirm appointments with customers immediately after booking by SMS, by default" switchName="confirm_notification" />

      <SwitchSection title="Disable Inbound Messaging" description="Disable inbound SMS messages. Customers will not be able to reply/send you messages. They will get auto-reply informing them that inbound messaging is disabled" switchName="disable_inbound" />

      <Section title="Appointment Reminder" description="Select how long before an appointment to send a reminder by SMS">
        <RadioCards options={[
          { title: "Day of", description: "Send a reminder on the day of the appointment", name: 0 },
          { title: "Day Before", description: "Send a reminder one day before the appointment", name: 1 },
          { title: "Two Days Before", description: "Send a reminder two days before the appointment", name: 2 },
          { title: "Week Before", description: "Send a reminder one week before the appointment", name: 7 },
        ]}
        fieldName="days_before_appointment"
        />
      </Section>

      <Section title="Wig Drop Off Reminder" description="Select how long before a wig drop off is scheduled to send a reminder by SMS">
        <RadioCards options={[
          { title: "Day of", description: "Send a reminder on the day the wig is scheduled to be dropped off", name: 0 },
          { title: "Day Before", description: "Send a reminder one day before the wig is scheduled to be dropped off", name: 1 },
        ]}
        fieldName="days_before_dropoff"
        />
      </Section>
      
      <Section title="Schedule Confirmation Message" description="Format the message that will be sent to the customer when they schedule an appointment">

        <TagRuleDescription>
          Set up the message by using the placeholders below.
          <TagRules>
            <li><b>{`{{first_name}}`}</b> will be replaced with the customer's first name</li>
            <li><b>{`{{last_name}}`}</b> will be replaced with the customer's last name</li>
            <li><b>{`{{full_name}}`}</b> will be replaced with the customer's full name</li>
            <li><b>{`{{stylist_name}}`}</b> will be replaced with the stylist name</li>
            <li><b>{`{{event_title}}`}</b> will be replaced with the event title, e.g. "Wash & Set"</li>
            <li><b>{`{{date}}`}</b> will be replaced with the event date</li>
            <li><b>{`{{start_time}}`}</b> will be replaced with the start time</li>
            <li><b>{`{{end_time}}`}</b> will be replaced with the end time</li>
            <li><b>{`{{location}}`}</b> will be replaced with your business location</li>
          </TagRules>
        </TagRuleDescription>
        <TagField placeholder="Event Description" variant="outlined" multiline minRows={3} fullWidth defaultValue={setting?.confirm_message} onChange={(e) => handleChange(e, "confirm_message")} slotProps={{spellCheck: false}} />
        {format_fields_errors?.confirm_message ? <ErrorList>
          {format_fields_errors?.confirm_message?.map((error, index) => <li key={index}>{error}</li>)}
        </ErrorList> : null}
        <Button variant="outlined" onClick={(e) => submitFormat(e, "confirm_message")}>Update Message</Button>
      
      </Section>

      <Section title="Wig Dropoff Reminder Message" description="Format the message that will be sent to the customer to remind them to drop off their wig">

        <TagRuleDescription>
          Set up the message by using the placeholders below.
          <TagRules>
            <li><b>{`{{first_name}}`}</b> will be replaced with the customer's first name</li>
            <li><b>{`{{last_name}}`}</b> will be replaced with the customer's last name</li>
            <li><b>{`{{full_name}}`}</b> will be replaced with the customer's full name</li>
            <li><b>{`{{stylist_name}}`}</b> will be replaced with the stylist name</li>
            <li><b>{`{{event_title}}`}</b> will be replaced with the event title, e.g. "Wash & Set"</li>
            <li><b>{`{{date}}`}</b> will be replaced with the event date</li>
            <li><b>{`{{start_time}}`}</b> will be replaced with the start time</li>
            <li><b>{`{{end_time}}`}</b> will be replaced with the end time</li>
            <li><b>{`{{location}}`}</b> will be replaced with your business location</li>
          </TagRules>
        </TagRuleDescription>
        <TagField placeholder="Event Description" variant="outlined" multiline minRows={3} fullWidth defaultValue={setting?.dropoff_message} onChange={(e) => handleChange(e, "dropoff_message")} slotProps={{spellCheck: false}} />
        {format_fields_errors?.dropoff_message ? <ErrorList>
          {format_fields_errors?.dropoff_message?.map((error, index) => <li key={index}>{error}</li>)}
        </ErrorList> : null}
        <Button variant="outlined" onClick={(e) => submitFormat(e, "dropoff_message")}>Update Message</Button>
      
      </Section>

      <Section title="Appointment Reminder Message" description="Format the message that will be sent to the customer before their scheduled appointment as a reminder">

        <TagRuleDescription>
          Set up the message by using the placeholders below.
          <TagRules>
            <li><b>{`{{first_name}}`}</b> will be replaced with the customer's first name</li>
            <li><b>{`{{last_name}}`}</b> will be replaced with the customer's last name</li>
            <li><b>{`{{full_name}}`}</b> will be replaced with the customer's full name</li>
            <li><b>{`{{stylist_name}}`}</b> will be replaced with the stylist name</li>
            <li><b>{`{{event_title}}`}</b> will be replaced with the event title, e.g. "Wash & Set"</li>
            <li><b>{`{{date}}`}</b> will be replaced with the event date</li>
            <li><b>{`{{start_time}}`}</b> will be replaced with the start time</li>
            <li><b>{`{{end_time}}`}</b> will be replaced with the end time</li>
            <li><b>{`{{location}}`}</b> will be replaced with your business location</li>
          </TagRules>
        </TagRuleDescription>
        <TagField placeholder="Event Description" variant="outlined" multiline minRows={3} fullWidth defaultValue={setting?.appt_message} onChange={(e) => handleChange(e, "appt_message")} slotProps={{spellCheck: false}} />
        {format_fields_errors?.appt_message ? <ErrorList>
          {format_fields_errors?.appt_message?.map((error, index) => <li key={index}>{error}</li>)}
        </ErrorList> : null}
        <Button variant="outlined" onClick={(e) => submitFormat(e, "appt_message")}>Update Message</Button>
      
      </Section>

      <Section title="Repair Pickup Reminder Message" description="Format the message that will be sent to the customer after repairs are completed as a reminder to pick them up">

        <TagRuleDescription>
          Set up the message by using the placeholders below.
          <TagRules>
            <li><b>{`{{first_name}}`}</b> will be replaced with the customer's first name</li>
            <li><b>{`{{last_name}}`}</b> will be replaced with the customer's last name</li>
            <li><b>{`{{full_name}}`}</b> will be replaced with the customer's full name</li>
            <li><b>{`{{location}}`}</b> will be replaced with your business location</li>
            <li><b>{`{{wig_id}}`}</b> will be replaced with the repair message</li>
          </TagRules>
        </TagRuleDescription>
        <TagField placeholder="Event Description" variant="outlined" multiline minRows={3} fullWidth defaultValue={setting?.repair_msg} onChange={(e) => handleChange(e, "repair_msg")} slotProps={{spellCheck: false}} />
        {format_fields_errors?.repair_msg ? <ErrorList>
          {format_fields_errors?.repair_msg?.map((error, index) => <li key={index}>{error}</li>)}
        </ErrorList> : null}
        <Button variant="outlined" onClick={(e) => submitFormat(e, "repair_msg")}>Update Message</Button>
      
      </Section>


    </Panel>
  )
};

export default GeneralTab;